"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = SocialIcon;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const defaultWidth = 20;
const defaultHeight = 20;
const defaultStrokeWidth = 2;
function SocialIcon({
  color,
  fillColor,
  icon,
  width,
  height,
  strokeWidth,
  title
}) {
  switch (icon) {
    default:
    case "facebook":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || defaultWidth,
        height: height || defaultHeight,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15 1.66675H12.5C11.395 1.66675 10.3352 2.10573 9.55376 2.88714C8.77236 3.66854 8.33337 4.72835 8.33337 5.83341V8.33341H5.83337V11.6667H8.33337V18.3334H11.6667V11.6667H14.1667L15 8.33341H11.6667V5.83341C11.6667 5.6124 11.7545 5.40044 11.9108 5.24416C12.0671 5.08788 12.279 5.00008 12.5 5.00008H15V1.66675Z",
        fill: fillColor
      }));
    case "instagram":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || defaultWidth,
        height: height || defaultHeight,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.1667 1.66675H5.83335C3.53217 1.66675 1.66669 3.53223 1.66669 5.83341V14.1667C1.66669 16.4679 3.53217 18.3334 5.83335 18.3334H14.1667C16.4679 18.3334 18.3334 16.4679 18.3334 14.1667V5.83341C18.3334 3.53223 16.4679 1.66675 14.1667 1.66675Z",
        fill: fillColor
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M13.3333 9.47501C13.4362 10.1685 13.3177 10.8769 12.9948 11.4992C12.6719 12.1215 12.1609 12.6262 11.5347 12.9414C10.9084 13.2566 10.1987 13.3663 9.50647 13.255C8.81425 13.1436 8.17478 12.8167 7.67901 12.321C7.18324 11.8252 6.85642 11.1857 6.74504 10.4935C6.63365 9.8013 6.74337 9.09159 7.05858 8.46532C7.3738 7.83905 7.87847 7.32812 8.5008 7.00521C9.12313 6.68229 9.83144 6.56383 10.525 6.66667C11.2324 6.77158 11.8874 7.10123 12.3931 7.60693C12.8988 8.11263 13.2284 8.76757 13.3333 9.47501Z",
        stroke: "white",
        strokeWidth: strokeWidth || defaultStrokeWidth,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.5833 5.41675H14.5916",
        stroke: "white",
        strokeWidth: strokeWidth || defaultStrokeWidth,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "linkedin":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || defaultWidth,
        height: height || defaultHeight,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
        d: "M13.3333 6.66675C14.6593 6.66675 15.9311 7.19353 16.8688 8.13121C17.8065 9.0689 18.3333 10.3407 18.3333 11.6667V17.5001H14.9999V11.6667C14.9999 11.2247 14.8243 10.8008 14.5118 10.4882C14.1992 10.1757 13.7753 10.0001 13.3333 10.0001C12.8912 10.0001 12.4673 10.1757 12.1547 10.4882C11.8422 10.8008 11.6666 11.2247 11.6666 11.6667V17.5001H8.33325V11.6667C8.33325 10.3407 8.86004 9.0689 9.79772 8.13121C10.7354 7.19353 12.0072 6.66675 13.3333 6.66675Z",
        fill: fillColor
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M5.00002 7.5H1.66669V17.5H5.00002V7.5Z",
        fill: fillColor
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M3.33335 5.00008C4.25383 5.00008 5.00002 4.25389 5.00002 3.33341C5.00002 2.41294 4.25383 1.66675 3.33335 1.66675C2.41288 1.66675 1.66669 2.41294 1.66669 3.33341C1.66669 4.25389 2.41288 5.00008 3.33335 5.00008Z",
        fill: fillColor
      }));
    case "twitter":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || defaultWidth,
        height: height || defaultHeight,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
        d: "M19.1666 2.50008C18.3686 3.06298 17.4851 3.4935 16.55 3.77508C16.0481 3.198 15.3811 2.78899 14.6392 2.60335C13.8973 2.41771 13.1162 2.46441 12.4017 2.73712C11.6872 3.00984 11.0737 3.49541 10.6441 4.12818C10.2146 4.76094 9.98973 5.51036 9.99998 6.27508V7.10841C8.53551 7.14639 7.08437 6.82159 5.77582 6.16295C4.46727 5.50431 3.34191 4.53228 2.49998 3.33341C2.49998 3.33341 -0.833354 10.8334 6.66665 14.1667C4.95042 15.3317 2.90594 15.9159 0.833313 15.8334C8.33331 20.0001 17.5 15.8334 17.5 6.25008C17.4992 6.01796 17.4769 5.78641 17.4333 5.55841C18.2838 4.71966 18.884 3.66067 19.1666 2.50008Z",
        fill: fillColor
      }));
    case "zillow":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || 23,
        height: height || 24,
        viewBox: "0 0 23 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.11 2L2.01 9.18917V12.4125C4.83167 10.735 11.3592 8.1375 14.3125 7.4C14.4042 7.38 14.4458 7.40417 14.5017 7.465C14.8117 7.82083 15.8233 9.0475 16.0983 9.3825C16.1088 9.39423 16.1165 9.40813 16.1209 9.42319C16.1254 9.43825 16.1265 9.45411 16.1241 9.46963C16.1217 9.48516 16.1159 9.49996 16.1071 9.51299C16.0984 9.52602 16.0868 9.53695 16.0733 9.545C14.0313 11.154 12.1679 12.9775 10.515 14.9842C10.49 15.015 10.51 15.02 10.525 15.0092C12.7267 14.0642 17.8817 12.5592 20.21 12.1325V9.18917L11.11 2ZM10.71 11.3142C8.93 11.9042 3.88083 14.07 2 15.1275V22H20.21V15.3867C17.7183 15.8083 10.2917 18.02 6.91083 19.7583C6.88037 19.7764 6.84458 19.7832 6.80961 19.7777C6.77465 19.7723 6.74267 19.7548 6.71917 19.7283L5.01583 17.7042C4.97 17.6533 4.96417 17.6225 5.025 17.5308C6.33667 15.6142 9.01583 12.615 10.7192 11.3492C10.7542 11.3242 10.745 11.2992 10.7092 11.3142H10.71Z",
        fill: fillColor
      }));
  }
}
SocialIcon.propTypes = {
  /**
   * Sets stroke color of icon
   */
  color: _propTypes.default.string,
  /**
   * Sets fill color of icon
   */
  fillColor: _propTypes.default.string,
  /**
   * Name of icon
   */
  icon: _propTypes.default.string.isRequired,
  /**
   * Sets width of icon
   */
  width: _propTypes.default.number,
  /**
   * Sets height of icon
   */
  height: _propTypes.default.number,
  /**
   * Sets stroke width of icon
   */
  strokeWidth: _propTypes.default.number,
  /**
   * Sets title of icon for accessibility
   */
  title: _propTypes.default.string
};
SocialIcon.defaultProps = {
  color: "#1a202c",
  // Orca Grey 8
  fillColor: "#1a202c",
  // Orca Grey 8
  title: ""
};
SocialIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SocialIcon",
  "props": {
    "color": {
      "defaultValue": {
        "value": "\"#1a202c\"",
        "computed": false
      },
      "description": "Sets stroke color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "fillColor": {
      "defaultValue": {
        "value": "\"#1a202c\"",
        "computed": false
      },
      "description": "Sets fill color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "title": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "description": "Sets title of icon for accessibility",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "icon": {
      "description": "Name of icon",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "width": {
      "description": "Sets width of icon",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "height": {
      "description": "Sets height of icon",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "strokeWidth": {
      "description": "Sets stroke width of icon",
      "type": {
        "name": "number"
      },
      "required": false
    }
  }
};